import { createWebHistory, createRouter } from 'vue-router'

import Login from "../Pages/Auth/Login.vue"
import Layout from "../Pages/Layout/Layout"
import Dashboard from "../Pages/Dashboard/Dashborad"
import Designation from "../Pages/Settings/Designation/Designation.vue"
import Slot from "../Pages/Settings/Slot/Slot.vue"
import AddSlot from "../Pages/Slot/AddSlot.vue"
import Construction from "../Pages/Settings/Construction/Construction.vue"
import Area from "../Pages/Settings/Area/Area.vue"
import EmployeeView from "../Pages/Employee/View.vue";
import Project from "../Pages/Settings/Project/Project.vue";
import District from "../Pages/Settings/District/District.vue";
import InvestorCategory from "../Pages/Settings/InvestorCategory/InvestorCategory.vue";
import Unit from "../Pages/Settings/Unit/Unit.vue";
import RawMaterial from "../Pages/Settings/RawMaterial/RawMaterial.vue";
import ExpenseCategory from "../Pages/Settings/ExpenseCategory/ExpenseCategory.vue";
import IncomeCategory from "../Pages/Settings/IncomeCategory/IncomeCategory.vue";
import Bank from "../Pages/Settings/Bank/Bank.vue";
import ShareholderAdd from "../Pages/Shareholder/Add.vue";
import Shareholder from "../Pages/Shareholder/Shareholder.vue";
import ShareholderEdit from "../Pages/Shareholder/Edit.vue";
import ShareholderView from "../Pages/Shareholder/View.vue";
import ExpenseAdd from "../Pages/Expense/Add.vue";
import Expense from "../Pages/Expense/Expense.vue";
import ExpenseEdit from "../Pages/Expense/Edit.vue";
import Income from "../Pages/Income/Income.vue";
import IncomeAdd from "../Pages/Income/Add.vue";
import IncomeEdit from "../Pages/Income/Edit.vue";
import BalanceSheet from "../Pages/Report/BalanceSheet.vue";
import Supplier from "../Pages/Settings/Supplier/Supplier.vue";
import Interest from "../Pages/Settings/Interest/Interest.vue";
import Contact from "../Pages/Settings/Contact/Contact.vue"
import CustomerAdd from "../Pages/Customer/Add.vue";
import Customer from "../Pages/Customer/Customer.vue";
import CustomerEdit from "../Pages/Customer/Edit.vue";
import ShareHolderList from "../Pages/Dashboard/ShareHolderList.vue";
import ShareholderDailyReport from "../Pages/Dashboard/ShareholderDailyReport.vue";
import SpecialExpense from "../Pages/Settings/SpecialExpense/SpecialExpense.vue";
import CashReceived from "../Pages/Settings/CashReceived/CashReceived.vue";
import OrderAdd from "../Pages/Order/Add.vue";
import Order from "../Pages/Order/Order.vue";
import OrderEdit from "../Pages/Order/Edit.vue";
import Purchase from "../Pages/Purchase/Purchase.vue";
import PurchaseAdd from "../Pages/Purchase/Add.vue";
import PurchaseEdit from "../Pages/Purchase/Edit.vue";
import PurchaseOrder from "../Pages/Order/PurchaseOrder.vue";
import OrderChallan from "../Pages/Order/OrderChallan.vue";
import OrderBill from "../Pages/Order/OrderBill.vue";
import PurchaseView from "../Pages/Purchase/View.vue";
import CashReceivedReport from "../Pages/Report/CashReceived.vue";
import IncomeCategoryReport from "../Pages/Report/IncomeCategory.vue";
import ExpenseCategoryReport from "../Pages/Report/ExpenseCategory.vue";
import SupplierReport from "../Pages/Report/Supplier.vue";
import RawMaterialReport from "../Pages/Report/RawMaterial.vue";
import DepositAmountReport from "../Pages/Report/DepositAmount.vue";
import SlotReport from "../Pages/Report/SlotReport.vue";
import SlotVsDepositByProject from "../Pages/Report/SlotVsDepositByProject.vue";
import SlotVsDepositByShareholder from "../Pages/Report/SlotVsDepositByShareholder.vue";
import DepositDetailsByShareholder from "../Pages/Report/DepositDetailsByShareholder.vue";
import PaymentMethodReport from "../Pages/Report/PaymentMethod.vue";
import RawMaterialAmount from "../Pages/Report/RawMaterialAmount.vue";
import SupplierAmount from "../Pages/Report/SupplierAmount.vue";
import CostingItem from "../Pages/Settings/CostingItem/CostingItem.vue";
import RawMaterialPurchase from "../Pages/Report/RawMaterialPurchase.vue";
import RawMaterialProfitList from "../Pages/RawMaterialProfit/List.vue";
import RawMaterialProfitAdd from "../Pages/RawMaterialProfit/Add.vue";
import RawMaterialProfitEdit from "../Pages/RawMaterialProfit/Edit.vue";
import SpecialExpenseReport from "../Pages/Report/SpecialExpense.vue";
import CostingItemReport from "../Pages/Report/CostingItem.vue";
import PurchaseByReport from "../Pages/Report/PurchaseBy.vue";
import BankWithdrawList from "../Pages/BankWithdraw/List.vue";
import BankWithdrawAdd from "../Pages/BankWithdraw/Add.vue";
import BankWithdrawEdit from "../Pages/BankWithdraw/Edit.vue";
import CustomerReference from "../Pages/Settings/CustomerReference/CustomerReference.vue";
import SalesPerson from "../Pages/Settings/SalesPerson/SalesPerson.vue";
import ShareHolderDepositReport from "../Pages/Report/ShareHolderDeposit.vue";
import ShareHolderProfitLossReport from "../Pages/Report/ShareHolderProfitLoss.vue";
import CategoryTopSheetReport from "../Pages/Report/CategoryTopSheet.vue";
import ShareHolderYearlyDepositReport from "../Pages/Report/ShareHolderYearlyDeposit.vue";
import ShareHolderMonthlyDepositReport from "../Pages/Report/ShareHolderMonthlyDeposit.vue";
import CategoryYearlyExpenseReport from "../Pages/Report/CategoryYearlyExpense.vue";
import CategoryMonthlyExpenseReport from "../Pages/Report/CategoryMonthlyExpense.vue";
import ComparisonExpenseSheetReport from "../Pages/Report/ComparisonExpenseSheet.vue";
import DayWiseExpenseReport from "../Pages/Report/DayWiseExpense.vue";
import DayWiseDepositReport from "../Pages/Report/DayWiseDeposit.vue";
import ShareHolderDailyDeposit from "../Pages/Report/ShareHolderDailyDeposit.vue";
import CategoryDailyExpense from "../Pages/Report/CategoryDailyExpense.vue";
import ShareholderBasicInfo from "../Pages/Shareholder/BasicInfo.vue";

const routes = [
    {
        name: "login",
        path: "/auth/login",
        component: Login,
        beforeEnter: authCheck,
    },
    {
        name: "layout",
        path: "/",
        component: Layout,
        beforeEnter: authRequestCheck,
        children: [
            { path: "/", name: "dashboard", component: Dashboard},
            { path: "/:id/shareholder", name: "shareHolderList", component: ShareHolderList},
            { path: "/:project_id/shareholder/:shareholder_id", name: "shareholderDailyReport", component: ShareholderDailyReport},
            { path: "/project", name: "project", component: Project},
            { path: "/district", name: "district", component: District},
            { path: "/designation", name: "designation", component: Designation},
            { path: "/slot", name: "slot", component: Slot},
            { path: "/construction", name: "construction", component: Construction},
            { path: "/area", name: "area", component: Area},
            { path: "/investor/category", name: "investorCategory", component: InvestorCategory},
            { path: "/unit", name: "unit", component: Unit},
            { path: "/raw/material", name: "rawMaterial", component: RawMaterial},
            { path: "/expense/category", name: "expenseCategory", component: ExpenseCategory},
            { path: "/income/category", name: "incomeCategory", component: IncomeCategory},
            { path: "/bank", name: "bank", component: Bank},
            { path: "/supplier", name: "supplier", component: Supplier},
            { path: "/specialExpense", name: "specialExpense", component: SpecialExpense},
            { path: "/cashReceived", name: "cashReceived", component: CashReceived},
            { path: "/costing/item", name: "costingItem", component: CostingItem},
            { path: "/customer-reference", name: "customerReference", component: CustomerReference},
            { path: "/sales-person", name: "salesPerson", component: SalesPerson},

            { path: "/shareholder", name: "shareholder", component: Shareholder},
            { path: "/shareholder/add", name: "shareholderAdd", component: ShareholderAdd},
            { path: "/shareholder/edit/:id", name: "shareholderEdit", component: ShareholderEdit},
            { path: "/shareholder/view/:id", name: "shareholderView", component: ShareholderView},
            { path: "/shareholder/basic-info/:id", name: "shareholderBasicInfo", component: ShareholderBasicInfo},

            { path: "/expense", name: "expense", component: Expense},
            { path: "/expense/add", name: "expenseAdd", component: ExpenseAdd},
            { path: "/expense/edit/:id", name: "expenseEdit", component: ExpenseEdit},

            { path: "/income", name: "income", component: Income},
            { path: "/income/add", name: "incomeAdd", component: IncomeAdd},
            { path: "/income/edit/:id", name: "incomeEdit", component: IncomeEdit},

            // { path: "/report/income", name: "incomeReport", component: IncomeReport},
            // { path: "/report/expense", name: "expenseReport", component: ExpenseReport},
            { path: "/report/balance-sheet", name: "balanceSheet", component: BalanceSheet},
            { path: "/report/cash-received", name: "cashReceivedReport", component: CashReceivedReport},
            { path: "/report/income-category", name: "incomeCategoryReport", component: IncomeCategoryReport},
            { path: "/report/expense-category", name: "expenseCategoryReport", component: ExpenseCategoryReport},
            { path: "/report/supplier", name: "supplierReport", component: SupplierReport},
            { path: "/report/raw-material", name: "rawMaterialReport", component: RawMaterialReport},
            { path: "/report/deposit-amount", name: "depositAmountReport", component: DepositAmountReport},
            { path: "/report/slot", name: "slotReport", component: SlotReport},
            { path: "/report/slot-vs-deposit-project", name: "slotVsDepositByProject", component: SlotVsDepositByProject},
            { path: "/report/slot-vs-deposit-shareholder", name: "slotVsDepositByShareholder", component: SlotVsDepositByShareholder},
            { path: "/report/deposit-details-by-shareholder", name: "depositDetailsByShareholder", component: DepositDetailsByShareholder},
            { path: "/report/payment-method", name: "paymentMethodReport", component: PaymentMethodReport},
            { path: "/report/raw-material-amount", name: "rawMaterialAmount", component: RawMaterialAmount},
            { path: "/report/supplier-amount", name: "supplierAmount", component: SupplierAmount},
            { path: "/report/raw-material-purchase", name: "rawMaterialPurchase", component: RawMaterialPurchase},
            { path: "/report/special-expense", name: "specialExpenseReport", component: SpecialExpenseReport},
            { path: "/report/costing-item", name: "costingItemReport", component: CostingItemReport},
            { path: "/report/purchase-by", name: "purchaseByReport", component: PurchaseByReport},
            { path: "/report/share-holder-deposit", name: "shareHolderDepositReport", component: ShareHolderDepositReport},
            { path: "/report/share-holder-profit-loss", name: "shareHolderProfitLossReport", component: ShareHolderProfitLossReport},
            { path: "/report/category-top-sheet", name: "categoryTopSheetReport", component: CategoryTopSheetReport},
            { path: "/report/share-holder-yearly-deposit", name: "shareHolderYearlyDepositReport", component: ShareHolderYearlyDepositReport},
            { path: "/report/share-holder-monthly-deposit/:year/:project_id", name: "shareHolderMonthlyDepositReport", component: ShareHolderMonthlyDepositReport},
            { path: "/report/category-yearly-expense", name: "categoryYearlyExpenseReport", component: CategoryYearlyExpenseReport},
            { path: "/report/comparison-expense-sheet", name: "comparisonExpenseSheetReport", component: ComparisonExpenseSheetReport},
            { path: "/report/category-monthly-expense/:year/:project_id", name: "categoryMonthlyExpenseReport", component: CategoryMonthlyExpenseReport},
            { path: "/report/category-daily-expense/:project_id/:year/:month_name", name: "categoryDailyExpenseReport", component: CategoryDailyExpense},
            { path: "/report/day-wise-expense", name: "dayWiseExpenseReport", component: DayWiseExpenseReport},
            { path: "/report/day-wise-deposit", name: "dayWiseDepositReport", component: DayWiseDepositReport},
            { path: "/report/shareholder-daily-deposit/:project_id/:year/:month", name: "shareHolderDailyDeposit", component: ShareHolderDailyDeposit},


            { path: "/employee/view/:id", name: "employeeView", component: EmployeeView},
            { path: "/interest", name: "interest", component: Interest},
            { path: "/contact", name: "contact", component: Contact},

            { path: "/customer", name: "customer", component: Customer},
            { path: "/customer/add", name: "customerAdd", component: CustomerAdd},
            { path: "/customer/edit/:id", name: "customerEdit", component: CustomerEdit},

            { path: "/order", name: "order", component: Order},
            { path: "/order/add", name: "orderAdd", component: OrderAdd},
            { path: "/order/purchase/:id", name: "purchaseOrder", component: PurchaseOrder},
            { path: "/order/challan/:id", name: "orderChallan", component: OrderChallan},
            { path: "/order/bill/:id", name: "orderBill", component: OrderBill},
            { path: "/order/edit/:id", name: "orderEdit", component: OrderEdit},

            { path: "/purchase", name: "purchase", component: Purchase},
            { path: "/purchase/add", name: "purchaseAdd", component: PurchaseAdd},
            { path: "/purchase/edit/:id", name: "purchaseEdit", component: PurchaseEdit},
            { path: "/purchase/view/:id", name: "purchaseView", component: PurchaseView},
            { path: "/raw-material-profit", name: "rawMaterialProfit", component: RawMaterialProfitList},
            { path: "/raw-material-profit/add", name: "rawMaterialProfitAdd", component: RawMaterialProfitAdd},
            { path: "/raw-material-profit/edit/:id", name: "rawMaterialProfitEdit", component: RawMaterialProfitEdit},

            { path: "/bank-withdraw", name: "bankWithdrawList", component: BankWithdrawList },
            { path: "/bank-withdraw/add", name: "addBankWithdraw", component: BankWithdrawAdd },
            { path: "/bank-withdraw/edit/:id", name: "editBankWithdraw", component: BankWithdrawEdit },
            { path: "/add-slot", name: "addSlot", component: AddSlot },
        ]
    }
]

function authCheck(to, from, next) {
    let token = localStorage.getItem('ligion_hrm_access_token');
    if (token !== undefined && token != null) {
        next('/');
    } else {
        next();
    }
}
function authRequestCheck(to, from, next) {
    let token = localStorage.getItem('ligion_hrm_access_token');
    if (token === undefined || token == null) {
        next('/auth/login');
    } else {
        next();
    }
}

const router = createRouter({
    history: createWebHistory(),
    routes,
})
export default router
